import { NAV_CTA, NAV_LOGIN } from './nav';

export interface FooterLink {
  label: string;
  to: string;
}

export interface FooterColumn {
  label: string;
  links: FooterLink[];
}

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    label: 'Melio',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Membership', to: '/membership' },
      { label: 'Assessments', to: '/assessments' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    label: 'Members',
    links: [
      { label: NAV_LOGIN.label, to: NAV_LOGIN.to },
      { label: NAV_CTA.label, to: NAV_CTA.to },
    ],
  },
];

export const FOOTER_LEGAL: FooterLink[] = [
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
];

export const FOOTER_WAITLIST_LABEL = 'Hear when a place opens';
